import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'
export default {
    namespaced: true,

    state() {
        return {           
            impersonateReason : []
        }
    },
    getters: {
        getImpersonateReason: state => state.impersonateReason
    },
    mutations: {
        setImpersonateReason(state, data) {
            state.impersonateReason = data
        },

    },
    actions: {
        getImpersonateReason({ commit, state }) {
            return new Promise((resolve, reject) => {
                Api.Impersonate.getImpersonateReasons()
                    .then(response => {
                        commit('setImpersonateReason', response.data.reasons)
                        return resolve(response.data.reasons)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        createImpersonation({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                Api.Impersonate.createImpersonation(data)
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        },
        endImpersonation({commit}) {
            return new Promise((resolve, reject) => {
                Api.Impersonate.endImpersonation()
                    .then(response => {
                        return resolve(response.data)
                    })
                    .catch((error) => {
                        const err = Errors.create(error)
                        reject(err)
                    })
            })
        }
    },
    modules: {
        errors: VuexErrors
    }
}